import React from "react";
import { cls } from "@wss/cls";
import FilterListItem from "./FilterListItem";
import { collapsedStyles } from "./FilterGroup";
import { GroupProps } from "./GroupProps";
import StandardIcon from "~/common/Icons/Standard";

const QuickShipFilter = ({
  groups,
  toggleCollapsed,
  groupsWithMultipleSelections,
  prefetch,
}: GroupProps) => (
  <>
    {groups.map((group) => (
      <li
        data-testid="QuickShipFilter"
        key="quickship"
        className={cls(
          "border-gray-200",
          "border-solid",
          "border-0",
          "first:border-t-0",
          "lt:border-t-0",
          "lt:mt-0",
        )}
      >
        <button
          type="button"
          className={cls(
            group.collapsed ? "collapsed mb-px lt:mb-0" : "",
            "bg-white",
            "border-gray-200",
            "border-solid",
            "border-0",
            "border-t",
            "block",
            "font-semibold",
            "text-base-1/2",
            "pl-2",
            "pr-3",
            "pt-1-1/2",
            "pb-px",
            "lt:py-0",
            "sticky",
            "-top-px",
            "text-left",
            "text-gray-800",
            "w-full",
            "lt:font-bold",
            "lt:text-sm-1/2",
            "lt:relative",
            "leading-6",
            "align-middle",
            "focus:outline-offset-[-7px]",
            "z-10",
          )}
          onClick={() => toggleCollapsed(group)}
          aria-expanded={!group.collapsed}
        >
          <span>{group.groupName}</span>
          <StandardIcon
            name="chevron-open"
            style={{
              right: 12,
              color: "#ccc",
              top: "50%",
            }}
            className={cls(
              "h-2",
              "absolute",
              "fill-current",
              "w-2",
              "transform",
              "-translate-y-1/2",
              "transition-all",
              "ease-in",
              "duration-300",
              group.collapsed && "rotate-180",
            )}
          />
        </button>
        <ul
          className={`${
            group.collapsed
              ? collapsedStyles
              : `${cls(
                  "bg-white",
                  "pl-4-1/2",
                  "m-0",
                  "lt:bg-transparent",
                  "lt:mt-0",
                  "lt:pl-0",
                  "pr-1",
                )} lt:pr-0`
          }`}
        >
          {group.groupItems.map((groupItem) => (
            <FilterListItem
              groupsWithMultipleSelections={groupsWithMultipleSelections}
              groupItem={groupItem}
              prefetch={prefetch}
              key={groupItem.nameEncoded}
              groupNameEncoded={group.groupNameEncoded}
              filterText="filter"
              labelImageUrl="//cdnimg.webstaurantstore.com/uploads/design/2020/9/quickship-icon.svg"
              labelImageWidth="22px"
              customLinkClass={cls(
                "focus:outline-offset-[-7px]",
                "mb-px",
                "lt:mb-0.5",
              )}
            />
          ))}
        </ul>
      </li>
    ))}
  </>
);

export default QuickShipFilter;
